export const SHIPPING_METHODS = {
  EXPRESS: 'Express',
  GREEN: 'Green',
  STANDARD: 'Standard',
  SHIP_FROM_STORE: 'Ship from store',
  PICKUP_POINT: 'Pick-up point (UPS, BOSS, BOPS)',
  BOSS: 'Buy online ship to store',

  GREEN_SHIPPING_ID_MOB: 'js-green-shipping',
  GREEN_SHIPPING_ID_DESK: 'wcs-shipping-selector-std_green',

  STD_SHIPPING_ID_MOB: 'js-standard-shipping',
  STD_SHIPPING_ID_DESK: 'wcs-shipping-selector-std',

  EXP_SHIPPING_ID_MOB: 'js-free-shipping',
  EXP_SHIPPING_ID_DESK: 'wcs-shipping-selector-exp',

  SFS_SHIPPING_ID_MOB: 'wcs-shipping-selector-sfs',
  SFS_SHIPPING_ID_DESK: 'wcs-shipping-selector-sfs',

  PUIS_SHIPPING_ID_MOB: 'js-pick-in-store-shipping',
  PUIS_SHIPPING_ID_DESK: 'wcs-shipping-selector-puis',

  SHIPPING_AVAILABLE_IN_PAYMENT: [
    'js-pick-in-store-shipping',
    'wcs-shipping-selector-puis',
    'wcs-shipping-selector-sfs',
  ],
}
